import {
  StyleSheet,
  Text,
  TouchableWithoutFeedback,
  View,
  ViewStyle,
} from "react-native";
import { Colors, Spacing, Typography } from "../../styles";
import { FontAwesome, Entypo } from "@expo/vector-icons";
import ProIcon from "../common/ProIcon";

interface Props {
  title: string;
  rows: {
    title: string;
    subtitle?: string;
    icon: "laptop" | "mobile-phone" | "user-o" | "shield";
    chevron?: "hidden" | "pro";
  }[];
  style?: ViewStyle;
}

const Card = ({ title, rows, style }: Props) => {
  return (
    <View style={[styles.container, style]}>
      <Text style={[Typography.paragraph, styles.title]}>{title}</Text>
      {rows.map((r, index) => (
        <>
          <View style={styles.row}>
            <View style={styles.row}>
              <View style={styles.icon}>
                <FontAwesome name={r.icon} size={30} color={Colors.white} />
              </View>

              <View>
                <Text style={Typography.paragraph}>{r.title}</Text>
                {r.subtitle && (
                  <Text style={[Typography.paragraph, { opacity: 0.5 }]}>
                    {r.subtitle}
                  </Text>
                )}
              </View>
            </View>
            {r.chevron === undefined && (
              <Entypo
                name="chevron-small-right"
                size={30}
                color={Colors.plum400}
              />
            )}
            {r.chevron === "pro" && <ProIcon />}
          </View>
          {index !== rows.length - 1 && <View style={styles.divider} />}
        </>
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    borderRadius: Spacing.cardRadius,
    padding: Spacing.card,
    backgroundColor: Colors.plum700,
  },
  title: {
    marginBottom: 20,
    fontSize: 16,
  },
  row: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  icon: {
    marginRight: 15,
    width: 35,
    justifyContent: "center",
    alignItems: "center",
  },
  divider: {
    height: 0.5,
    backgroundColor: Colors.plum400,
    marginVertical: 20,
  },
});

export default Card;
